module.exports = __webpack_public_path__ + "img/hands-holding-child.cd2da570.svg";